import { createSelector } from 'reselect';
import { aspectRootReducerStateKey } from '../rootReducer';
import { CoreState } from '../types';

type RootState = {
  [aspectRootReducerStateKey]: CoreState;
};

export const getSlice = (state: RootState): CoreState => state[aspectRootReducerStateKey];

export const getColor = createSelector(getSlice, coreState => coreState.color);
